











































































































































































































































































































































































































































































































































































































































import {Vue, Component} from 'vue-property-decorator';
import SubscriptionPlanService from "@/services/SubscriptionPlanService";
import Notifications from "@/state/Notifications";
import {processError} from "@/utils/ComponentUtils";
import PortalDictionaryDTO from "@/dto/common/PortalDictionaryDTO";
import PayPalPlanDTO from "@/dto/subscription/PayPalPlanDTO";
import { DiscountActionType, DiscountScope, SubscriberType } from "@/constants/SubscriptionConstants";

@Component({})
export default class PriceList extends Vue {

  groups: Array<PortalDictionaryDTO> = []
  groupedSubscriptions: Array<{ groupName: string; subscriberType: SubscriberType; plansByPeriod: Record<string, PayPalPlanDTO>; hasDiscount: boolean; }> = []
  availablePeriodicities: string[] = []

  mounted(): void {
    this.loadGroups().then(
        ok => {
          this.loadPayPalPlans()
        },
        err => processError(err, this)
    )
  }

  async loadGroups() {
    return SubscriptionPlanService.getAllGroupsWithActivePlans().then(
        ok => {
          this.groups = ok.data;
        }
    )
  }

  async loadPayPalPlans(): Promise<void> {
    const groupedMap: Record<string, { groupName: string; subscriberType: SubscriberType; plansByPeriod: Record<string, PayPalPlanDTO>; hasDiscount: boolean; }> = {};
    const periodicities = new Set<string>();

    const promises = this.groups.map(g =>
      SubscriptionPlanService.getActivePayPalPlans(g.name).then(
        ok => {
          const plans = ok.data || [];
          plans.forEach((plan: PayPalPlanDTO) => {
            periodicities.add(plan.periodicity);
            const key = plan.sublimePlanGroupName || g.name;
            if (!groupedMap[key]) {
              groupedMap[key] = {
                groupName: key,
                subscriberType: plan.subscriberType,
                plansByPeriod: {},
                hasDiscount: false
              };
            } else {
              groupedMap[key].subscriberType = this.mergeSubscriberTypes(groupedMap[key].subscriberType, plan.subscriberType);
            }
            groupedMap[key].plansByPeriod[plan.periodicity] = plan;
            if (this.hasDiscount(plan)) {
              groupedMap[key].hasDiscount = true;
            }
          });
        }
      )
    );

    return Promise.all(promises).then(
      () => {
        const order = ['MONTHLY', 'QUARTERLY', 'SEASONLY', 'ANNUALLY'];
        const periods = Array.from(periodicities);
        periods.sort((a, b) => order.indexOf(a) - order.indexOf(b));
        this.availablePeriodicities = periods;
        this.groupedSubscriptions = Object.values(groupedMap).sort((a, b) => this.getGroupDisplayName(a.groupName).localeCompare(this.getGroupDisplayName(b.groupName)));
        this.$loadOff();
      },
      err => { this.$loadOff(); processError(err, this); }
    );
  }

  private hasDiscount(plan: PayPalPlanDTO): boolean {
    return !!(plan.discounts && plan.discounts.length > 0 &&
      plan.discounts.some(d => d.scope === DiscountScope.EACH_CONSOLIDATED_OWNER && d.actionType === DiscountActionType.FIXED_UNIT_PRICE_CENTS));
  }

  private getDiscountedPrice(plan: PayPalPlanDTO): number | null {
    if (!this.hasDiscount(plan)) {
      return plan.currentUnitPriceCents;
    }
    const discount = plan.discounts.find(d => d.scope === DiscountScope.EACH_CONSOLIDATED_OWNER && d.actionType === DiscountActionType.FIXED_UNIT_PRICE_CENTS);
    return discount ? discount.actionValue : plan.currentUnitPriceCents;
  }

  private formatPrice(priceCents: number | null): string {
    if (priceCents === null) return '0.00';
    return (priceCents / 100).toFixed(2);
  }

  private formatPeriodicityShort(periodicity: string): string {
    const key = `subscriptions.periodicity.short.${periodicity}`;
    return this.$t ? String(this.$t(key)) : periodicity;
  }

  private getGroupDisplayName(groupName: string): string {
    const found = this.groups.find(g => g.name === groupName);
    if (!found) return groupName;
    const locale = this.$i18n.locale || 'en';
    if (locale == 'ru') {
      return found.valueRu || found.valueEn || found.name;
    }
    return found.valueEn || found.valueRu || found.name;
  }

  private getTypeLabelKey(isBase: boolean, subscriberType: SubscriberType): string {
    if (subscriberType === SubscriberType.COMPANY) {
      return isBase ? 'subscriptions.type.company.base' : 'subscriptions.type.company.additional';
    }
    // Default to person profile wording
    return isBase ? 'subscriptions.type.person.base' : 'subscriptions.type.person.additional';
  }

  private mergeSubscriberTypes(a: SubscriberType, b: SubscriberType): SubscriberType {
    if (a === b) return a;
    if (a === SubscriberType.ALL || b === SubscriberType.ALL) return SubscriberType.ALL;
    return SubscriberType.ALL;
  }

}
